module.exports = __webpack_public_path__ + "img/Average.9c3640d5.svg";